<template>
  <nav class="navbar navbar-expand-lg navbar-light nav-bg">
    <div class="container-fluid px-5">
      <router-link
        style="
          font-weight: bold;
          font-size: 32px;
          color: #555;
          padding-top: 10px;
          padding-bottom: 10px;
          color: #95c7c4;
        "
        class="navbar-brand"
        :to="{ name: 'Home' }"
        >VueBlog</router-link
      >
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mb-2 mb-lg-0" style="margin-left: auto">
          <li class="nav-item header-item">
            <router-link
              class="nav-link link-text"
              v-bind:class="{ active: this.$route.name === 'Home' }"
              aria-current="page"
              to="/"
              >Home</router-link
            >
          </li>
          <li class="nav-item header-item">
            <router-link
              class="nav-link link-text"
              v-bind:class="{ active: this.$route.name === 'Blogs' }"
              aria-current="page"
              to="/blogs"
              >Blogs</router-link
            >
          </li>
          <li class="nav-item header-item" v-if="this.$store.state.isLoggedIn">
            <router-link
              class="nav-link link-text"
              aria-current="page"
              to="/createpost"
              >Create Post</router-link
            >
          </li>
          <li class="nav-item header-item" v-if="!this.$store.state.isLoggedIn">
            <router-link
              class="nav-link link-text"
              aria-current="page"
              to="/login"
              >Login/Register</router-link
            >
          </li>
          <li
            class="nav-item dropdown header-item"
            v-if="this.$store.state.isLoggedIn"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Profile
            </a>
            <div
              class="dropdown-menu custom-nav"
              aria-labelledby="navbarDropdown"
            >
              <router-link
                class="dropdown-item"
                to="/profile"
                style="color: white"
              >
                <i class="fas fa-user auth-icon mr-2" style="color: #95c7c4"></i
                >User Profile</router-link
              >
              <router-link
                class="dropdown-item"
                to="/userblogs"
                style="color: white"
              >
                <i
                  class="fas fa-th-large auth-icon mr-2"
                  style="color: #95c7c4"
                ></i
                >User Blogs</router-link
              >
              <!-- <a class="dropdown-item" href="#" @click="logOut">Logout</a> -->
              <router-link
                class="dropdown-item"
                style="color: white"
                to="#"
                @click.prevent="logOut"
              >
                <i
                  class="fas fa-sign-out-alt auth-icon mr-2"
                  style="color: #95c7c4"
                ></i
                >Logout</router-link
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "NavComponent",
  data() {
    return {
      profileMenu: true,
    };
  },
  methods: {
    async logOut() {
      await firebase.auth().signOut();
      this.$store.commit("resetState");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.header-item {
  padding-right: 10px;
  font-size: 14px;
}
.nav-bg {
  background-color: white !important;
}
.nav-link {
  color: black !important;
}
.link-text:hover,
.active {
  color: #1eb8b8 !important;
}
.custom-nav {
  background-color: #303030 !important;
  color: white;
}
</style>